<template>
  <div class="page--login">
    <OverlayLoader v-if="loading"></OverlayLoader>
    <div class="login-left">
      <img class="login-bg" src="../../assets/images/login-pic.jpg">
      <img class="login-bg-m" src="../../assets/images/login-pic-m.jpg">
    </div>

    <div class="login-right">
      <div class="login-right-content">
        <!-- step 1 -->
          <h1>Terms and conditions</h1>
          <div class="form-row">
            <div class="form-cell">
              <div class="form-block">
                <p class="login-info" v-html="withBrTags(agreement.value)"></p>
              </div>
              <button class="button--submit" @click="submitAgreement">{{agreement.valueDescription}}</button>
              <p class="login-info"><router-link to="/company-select">Return to previous page</router-link></p>
            </div>
          </div>
      </div>
      <div class="login-footer">All rights reserved by Capgemini. <br>Copyright © {{ new Date().getFullYear() }}</div>
    </div>
  </div>
</template>

<script>
import api from '@/api/settingUser'
import settings from "@/settings";
import OverlayLoader from "@/components/general/OverlayLoader";

export default {
name: "Agreement",
  components: {OverlayLoader},
  data() {
  return {
    loading: false,
  }
},
computed: {
  agreement() {
    let agreement = this.$store.getters.settingsCompanyByCode(settings.SETTING_TYPES.AGREEMENT_NEEDED)
    if(agreement && agreement[0]) {
      return agreement[0]
    }
    return null
  }
},
mounted() {
  if(!this.agreement) {
    this.$router.push('/')
  }
  window._paq.push(['setUserId', this.$store.getters.user.email])
  window._paq.push(['setCustomDimension', 2, this.$store.getters.selectedCompanyName])
  window._paq.push(['trackPageView', 'Agreement', {dimension1: this.$store.getters.selectedCompanyName}]);
},
methods: {
  withBrTags(string) {
    return string.replace(/(\\r)*\\n/g, '<br>')
  },
  submitAgreement() {
    this.loading = true;
    api.createSettingUser({
      idUser: this.$store.getters.user.idUser,
      idSettingCompany: this.agreement.idSettingCompany,
      valueInt: 1
    }, () => {
      this.$router.push('/')
    })
  }
}
}
</script>

<style scoped>

</style>
